import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

const STORAGE_KEY = 'skusavvy-screenshot-randomize';
const ScreenshotModeContext = createContext(null);

function readEnabled() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function ScreenshotModeProvider({ children }) {
  const user = useSelector((state) => state.user);
  const isSuperAdmin = user?.role === 'Super Admin';
  const [enabled, setEnabled] = useState(readEnabled);

  useEffect(() => {
    if (!isSuperAdmin && enabled) {
      setEnabled(false);
      try {
        sessionStorage.removeItem(STORAGE_KEY);
      } catch {}
    }
  }, [enabled, isSuperAdmin]);

  const toggle = useCallback(() => {
    if (!isSuperAdmin) return;
    setEnabled((current) => {
      const next = !current;
      try {
        sessionStorage.setItem(STORAGE_KEY, String(next));
      } catch {}
      return next;
    });
  }, [isSuperAdmin]);

  const value = useMemo(
    () => ({ enabled: isSuperAdmin && enabled, isSuperAdmin, toggle }),
    [enabled, isSuperAdmin, toggle],
  );

  return <ScreenshotModeContext.Provider value={value}>{children}</ScreenshotModeContext.Provider>;
}

export function useScreenshotMode() {
  const context = useContext(ScreenshotModeContext);
  if (!context) {
    throw new Error('useScreenshotMode must be used inside ScreenshotModeProvider');
  }
  return context;
}
